<script lang="ts">
  import ProductContent from '$lib/components/product/ProductContent.svelte'
  import ProductData from '$lib/components/product/ProductData.svelte'
  import StructuredData from '$lib/components/common/StructuredData.svelte';
  import { storeVisitedProducts } from '$lib/js/stores'
  import { containsProduct, is_set_object, isSequraActive } from '$lib/js/helpers';
  import { getBreadcrumbsSchema, getMerchantSchema } from "$lib/js/structured_data";
  import { page } from '$app/stores';
  import { afterNavigate, beforeNavigate } from '$app/navigation';
  import { registerViewItemEvent } from '$lib/js/ga4/events';
  import { getContextScope } from '$lib/js/helpers/i18n'

  const scope = getContextScope()

  $: innerWidth = 0;

  /** @type FullProduct */
  $: product = $page.data.product

  beforeNavigate(() => {
    if(containsProduct(product, $storeVisitedProducts) === false) {
      $storeVisitedProducts.unshift(product)

      if($storeVisitedProducts.length >= 9) {
        $storeVisitedProducts = $storeVisitedProducts.slice(0, 8)
      }

      $storeVisitedProducts = $storeVisitedProducts
    }
  })

  afterNavigate(() => {
    if(isSequraActive($page.data?.settings, product?.category_ids)) {
      window.Sequra.onLoad(function () {
        window.Sequra.refreshComponents();
      });
    }
    registerViewItemEvent($page.data.product, $page.data.brand)
  })

  /* Structured data */
  // let video = $page.data.product.media_gallery.filter((e) => {
  //   return e.vid !== undefined;
  // });
</script>


<StructuredData schema={getMerchantSchema($page.data.product, {brand: $page.data.brand, reviews: $page.data.reviews, scope: scope})}/>

<!-- Exception for products with no category
     Note: product.category is a list. -->
{#if is_set_object($page.data.product.category)}
  <StructuredData schema={getBreadcrumbsSchema($page.data.product.category)}/>
{/if}

<!-- Video structured data -->
<!-- {#if is_set_object(video)}
  <StructuredData schema={getVideoSchema(video[0])}/>
{/if} -->

<svelte:head>
  {#if isSequraActive($page.data?.settings)}
    <!--suppress CommaExpressionJS, ES6ConvertVarToLetConst, JSValidateTypes -->
    {#if scope === "fr"}
      <script>window.sequra_locale = "fr-FR"</script>
    {:else if scope === "es"}
      <script>window.sequra_locale = "es-ES"</script>
    {:else}
      <script>window.sequra_locale = "en-US"</script>
    {/if}

    <script>
      var sequraConfigParams = {
        merchant: "bixoto", // Your merchant reference given by SeQura.
        assetKey: "McY_O5ODVg", // Your asset key given by SeQura.
        products: ["pp3"], // List of SeQura products that you want to include components.
        scriptUri: "https://live.sequracdn.com/assets/sequra-checkout.min.js", // SeQura Javascript library uri for production or sandbox.
        decimalSeparator: ".", // Decimal separator used in currencies formatting. Optional, default `,`.
        locale: window.sequra_locale, // Language and country codes separated by hyphen -. Optional, default `es-ES`.
        currency: "EUR", // Currency code available for chosen locale. Optional, default `EUR`.
      };

      // @ts-ignore
      // @formatter:off
      (function(i, s, o, g, r, a, m) {i["SequraConfiguration"] = g;i["SequraOnLoad"] = [];i[r] = {};i[r][a] = function(callback) {i["SequraOnLoad"].push(callback);};(a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);a.async = 1;a.src = g.scriptUri;m.parentNode.insertBefore(a, m);})(window, document, "script", sequraConfigParams, "Sequra", "onLoad");
    </script>
  {/if}
</svelte:head>

<svelte:window bind:innerWidth />


{#key product}
  <!-- <MarqueeBanner duration="{15}" repeat="{5}">
    <span class="bf">BLACK FRIDAY</span>
    <span class="text">¡Descuentos especiales en todos nuestros productos Farmina!</span>
    <span class="discounts">-15%  |  -20%  |  -25%  |  -30%</span>
  </MarqueeBanner> -->
  <!-- <TopCatBanner /> -->
  <!-- <FullTopBanner /> -->

  <div class="container-special">
    <div class="product-info">
      <div class="container-special">

        <div class="product-info__inner">
          <div class="product-info__left">
            <ProductContent {product}/>
          </div>

          {#if $page.data.mobile === false || innerWidth > 768}
            <div class="product-info__content">
              <ProductData {product} />
            </div>
          {/if}
        </div>
      </div>
    </div>
  </div>
{/key}

<!-- <ValueModal />
<CompensationModal /> -->


<style lang="scss">
  .container-special {
    max-width: 1440px;
    margin: 0 auto 100px;
  }
  /* (unused selectors)
  .bf, .discounts, .text {
    margin-right: 160px;
    font-size: 24px;
  } */
  .product-info {
    &__inner {
      position: relative;

      @media (min-width: 769px) {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
    }

    &__left {
      @media (min-width: 769px) {
        width: calc(100% - 340px);
      }

      @media (min-width: 1201px) {
        width: calc(100% - 415px);
      }
    }

    &__content {
      height: calc(100vh - 100px);

      @media (max-width: 768px) {
        display: none;
      }

      @media (min-width: 769px) {
        position: sticky;
        right: 0;
        top: 100px;
        bottom: 0;
        width: 340px;
      }

      @media (min-width: 1201px) {
        width: 415px;
      }
    }
  }
</style>
